var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"TreeChart",staticStyle:{"width":"100%","height":"100%"},on:{"wheel":function($event){$event.preventDefault();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }